import styled from "styled-components";
import HelperSection from "./HelperSection";
import { GridContainer } from "./HomeStyle";
import ContentCard from "./ContentCard";
import NaraIcon from "assets/icons/nara-logo.png";
import { ChevronLeftIcon } from "icons/ArrowLeftIcon";
import miniCalenderIcon from "assets/icons/miniCalenderIcon.svg";
import boltIcon from "assets/icons/boltIcon.svg";
import { useHistory } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .headerText {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    color: ${(props) => props.headerColor || "#07070c"};
  }

  .cardContainer {
    .card {
      &:hover {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1),
          0px 25px 35px 0px rgba(188, 169, 169, 0.1);
      }
    }
    @media (max-width: 768px) {
      display: flex;
      overflow-x: auto;

      .card {
        min-width: 70%;
        max-width: 70%;
      }
    }
  }
`;

const MoreThings = () => {
  const history = useHistory();
  const data = [
    {
      header: <img src={NaraIcon} width="20px" alt="nara" />,
      content: "Create on brand post captions with Nara social media assistant",
      actionIcon: <ChevronLeftIcon color="#656575" size={16} />,
      onClick: () => history.push("/dashboard/nara/home"),
    },
    {
      header: <img src={miniCalenderIcon} alt="nara" />,
      content: "Create and plan your content for the entire month ",
      actionIcon: <ChevronLeftIcon color="#656575" size={16} />,
      onClick: () => history.push("/dashboard/calendar"),
    },
    {
      header: <img src={boltIcon} alt="nara" />,
      content: "Create auto replies for your comments and DMs",
      actionIcon: <ChevronLeftIcon color="#656575" size={16} />,
      onClick: () => history.push("/dashboard/automation"),
    },
  ];
  return (
    <Wrapper>
      <p className="headerText">More things to do</p>

      <GridContainer
        columns="repeat(3, 1fr)"
        gap="24px"
        // mbColumn="repeat(3, 1fr)"
        className="cardContainer"
      >
        {data.map((item, index) => (
          <ContentCard
            key={index}
            {...item}
            descriptionSize={16}
            className="card"
          />
        ))}
      </GridContainer>
    </Wrapper>
  );
};

export default MoreThings;
